import $ from "jquery";
import Cookies from 'js-cookie';

const smallPromoBanner = {

    banners: $('.small-promo-banner'),

    init() {
        this.bindCloseButton();
        this.initShown();
    },

    bindCloseButton() {
        this.banners.each(function (i, item) {
            $(item).on('click', '.icon-close', (evt) => {
                evt.preventDefault();
                let bannerId = $(this).attr('id');
                hideBanner(bannerId);
            });
        });
    },

    initShown() {
        this.banners.each(function (i, item) {
            let bannerId = $(item).attr('id');
            isShownBanner(bannerId);
        });
    }
};

function hideBanner(id) {
    Cookies.set(id, id, {expires: 1});
    isShownBanner(id);
}

function isShownBanner(id) {
    if (Cookies.get(id) === undefined) {
        $('#' + id).removeClass('ng-hide');
    } else {
        $('#' + id).addClass('ng-hide');
    }
}

// DOM ready
$(() => {
    if (smallPromoBanner.banners.length) {
        smallPromoBanner.init();
    }
});

export default smallPromoBanner;
